// ===== 5. Main Soft Approval Component =====
// src/components/SoftApprovalSection.tsx

import React from 'react';
import { Box, Fade } from '@mui/material';
import { useSoftApproval } from './useSoftApproval';
import SoftApprovalStatusCard from './SoftApprovalStatusCard';
import SoftApprovalIssues from './SoftApprovalIssues';

interface SoftApprovalSectionProps {
  applicationData: any;
  onNavigateToSection?: (section: string) => void;
  triggerAnalysis?: boolean;
}

const SoftApprovalSection: React.FC<SoftApprovalSectionProps> = ({
  applicationData,
  onNavigateToSection,
  triggerAnalysis = true
}) => {
  const { analysis, loading, error, retryAnalysis } = useSoftApproval(applicationData, triggerAnalysis);

  return (
    <Fade in={true} timeout={500}>
      <Box>
        <SoftApprovalStatusCard
          analysis={analysis}
          loading={loading}
          error={error}
          onRetry={retryAnalysis}
        />
        
        {analysis && (
          <SoftApprovalIssues
            criticalIssues={analysis.criticalIssues}
            warnings={analysis.warnings}
            suggestions={analysis.suggestions}
            nextSteps={analysis.nextSteps}
            onNavigateToSection={onNavigateToSection}
          />
        )}
      </Box>
    </Fade>
  );
};

export default SoftApprovalSection;

//---------------------------------------------------------------------------------------------------------------------------------------------------